import {BoxSchema} from 'samples/storables/StorableSchemaConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

import {CreateBoxSchemaParams, UpdateBoxSchemaParams} from './SampleSchemaActions';

export function fetchAll(): JQueryPromise<{data: Array<BoxSchema>}> {
  return net.getJSON('/1/api/box-schemas');
}

interface CreateBoxSchemaWithRegistryId extends CreateBoxSchemaParams {
  registryId: string;
}

export function create(data: CreateBoxSchemaWithRegistryId): JQueryPromise<BoxSchema> {
  return net.postJSON({url: '/1/api/box-schemas', data});
}

export function deleteBoxSchema(boxSchemaId: string): JQueryPromise<{}> {
  return net.delete_({url: `/1/api/box-schemas/${boxSchemaId}`});
}

export function update(boxSchemaId: string, data: UpdateBoxSchemaParams): JQueryPromise<BoxSchema> {
  return TaskRunner.patchJSON({url: `/1/api/box-schemas/${boxSchemaId}`, data});
}
